

















import Vue from 'vue'
import Component from 'vue-class-component'
import DepartmentList from '@/modules/reservation/components/DepartmentList.vue'
import {Prop} from 'vue-property-decorator'

/**
 * Muestra al usuario la lista de departamento y permite seleccionar uno
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {DepartmentList},
})
export default class DepartmentSelect extends Vue {
    /**
     * Controla la visibilidad de la pantalla
     */
    @Prop({type: Boolean, default: false})
    public value: boolean
}
